
<template>
    <section class="get-started-wrapper position-relative pb-80px pt-80px overflow-hidden" :style="'background-image: url('+dlabData.getStarted.bgImage+')'">
        <div class="container">
            <div class="section-header text-center">
                <h1 v-if="dlabData.getStarted.title" class="section-title" v-html="dlabData.getStarted.title"></h1>
                <p v-if="dlabData.getStarted.description" class="section-desc">{{dlabData.getStarted.description}}</p>
            </div>
            <div class="row responsive-tablet-col-2 responsive-mobile-col-1">
                <div class="col-md-4" v-for="(item, i) in dlabData.getStarted.items" :key="i">
                    <get-started-items :item="item" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import dlabData from '@/store/store.js'
import GetStartedItems from '../cards/GetStartedItems.vue'

export default {
  components: {
        GetStartedItems
    },
    name: 'GetStarted',
    data() {
        return {
            dlabData
        }
    }
}
</script>